import { reduce } from 'lodash';

export const seriesIds = ({ inCartSeries }) => inCartSeries.indexIds;

export const inCartSelected = ({ inCartTemplates }, { seriesId }) =>
  Object.values(inCartTemplates.byId)
    .filter(template => template.seriesId === seriesId && template.selected)
    .reduce((sum, template) => {
      let templateSum = reduce(
        template.prioritiesToQuantitiesMap,
        function(result, value, key) {
          return result + value;
        },
        0,
      );
      return (sum += templateSum);
    }, 0);

export const serieModelIds = ({ inCartSeries, inCartModels }, { seriesId }) =>
  Object.values(inCartModels.byId)
    .filter(model => model.seriesId === seriesId)
    .map(model => model.id);
